// src/views/Employees/Modal/EmployeeModal.jsx
import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ActionsDataTable from "./ActionsDataTable";
import EditAttendanceSessionModal from "./EditAttendanceSessionModal";
import { employeeConstants, modeConstants } from "../constants";
import { success } from "../redux/actions/utilities";
import { employeeActions } from "../redux/actions";
import { Modal, Button } from "react-bootstrap";
import ViewAttendanceSessionsModal from "./ViewAttendanceSessionsModal";
import { ToastifyService } from "../services";

export default function ViewAttendancePerDateModal({ show, onHide }) {
  const initialGridState = {
      column: "",
      type: "",
      search: null,
      filters: [],
    };
  
    const dispatch = useDispatch();
    const sortingInProgressRef = useRef(false);
    const [gridState, setGridState] = useState(initialGridState);
    const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);
    const [showModal, setShowModal] = useState(false);
    const [mode, setMode] = useState(modeConstants.ADD_MODE);
    // modal + row state
    const [rowData, setRowData] = useState([]);
    const [viewModal, setShowViewModal] = useState(false);
    const [copied, setCopied] = useState(false);
    const [filterType, setFilterType] = useState("all");
    const [duplicateShow, setDuplicateShow] = useState(false);
    const [targetDate, setTargetDate] = useState("");
    const [selectedRow, setSelectedRow] = useState(null);
  
    const allData = useSelector((s) => s.employeeReducer.employeeAttendance);
    const userId  = useSelector((s) => s.employeeReducer.userId);
    // filters aligned to table fields
    const filterColumns = [];
  
    const columns = [
      {
        name: "Sr. No",
        selector: (row, index) => index + 1,
        sortable: false,
        width: "100px",
      },
      {
        id: "date",
        name: "Date",
        selector: (row) => row.date,
        sortable: true,
        cell: (row) => {
          const date = row.date ? new Date(row.date).toLocaleDateString() : "-";
          return (
            <div className="d-flex align-items-center">
              <span>{date}</span>
            </div>
          );
        },
      },
      {
        id: "name",
        name: "Name",
        selector: (row) => row.name,
        sortable: true,
        cell: (row) => (
          <div className="d-flex align-items-center">
            <span>{row.name}</span>
          </div>
        ),
      },
      {
        id: "total_duration",
        name: "Total Hours",
        selector: (row) => row.total_duration,
        sortable: true,
        cell: (row) => (
          <div className="d-flex align-items-center">
            <span>{row.total_duration}</span>
          </div>
        ),
      },
      {
        name: "Actions",
        sortable: false,
        width: "170px",
        cell: (row) => (
          <div
            className="d-flex align-items-center gap-2"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="btn btn-sm btn-outline-success"
              title="View"
              aria-label="View"
              onClick={() => {
                getRowData(row);
                setShowViewModal(true);
              }}
            >
              <i className="bi bi-eye" />
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              title="Duplicate"
              aria-label="Duplicate"
              onClick={() => {
                setSelectedRow(row);
                setDuplicateShow(true);
              }}
            >
              <i className="bi bi-files" />
            </button>
          </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    ];
  
    const getRowData = (row) => {
      const sessionsWithDate = (row.sessions || []).map((s) => ({
        ...s,
        parent_date: row.date,
      }));
      dispatch(success(sessionsWithDate, employeeConstants.EMPLOYEE_SESSIONS));
    };
    const onSort = (sortedColumn, sortDirection) => {
      sortingInProgressRef.current = true;
      const columnDirection = sortDirection ? sortDirection.toUpperCase() : null;
      setDefaultPage(gridState.pageNumber);
      setGridState((prevState) => ({
        ...prevState,
        orderBy:
          columnDirection !== null ? `${sortedColumn.id} ${columnDirection}` : "",
      }));
    };
  
    const onChangePage = (pageNumber) => {
      if (!sortingInProgressRef.current) {
        setGridState((prevState) => ({
          ...prevState,
          pageNumber: pageNumber,
        }));
      }
    };
  
    const onChangeRowsPerPage = (newPerPage, pageNumber) => {
      setGridState((prevState) => ({
        ...prevState,
        length: newPerPage,
        pageNumber: pageNumber,
      }));
    };

  
    // Daily, weekly, monthly date filters helper
    const filterData = (data, type) => {
      if (!data) return [];
      if (type === "all") return data;

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return data.filter((row) => {
        if (!row.date) return false;
        const rowDate = new Date(row.date);
        rowDate.setHours(0, 0, 0, 0);

        if (type === "daily") {
          return rowDate.getTime() === today.getTime();
        }

        if (type === "weekly") {
          const startOfWeek = new Date(today);
          startOfWeek.setDate(today.getDate() - 7);
          return rowDate >= startOfWeek && rowDate <= today;
        }

        if (type === "monthly") {
          const startOfMonth = new Date(today);
          startOfMonth.setDate(today.getDate() - 30);
          return rowDate >= startOfMonth && rowDate <= today;
        }

        return true;
      });
    };

    useEffect(() => {
      if (allData !== null) {
        setRowData(filterData(allData, filterType));
      }
    }, [allData, filterType]);

  const handleDuplicateSubmit = () => {
    if (!selectedRow || !targetDate) return;
    
    const payload = {
      user_id: userId,
      source_date: selectedRow.date,
      target_date: targetDate,
    };

    dispatch(employeeActions.duplicateAttendance(payload, userId));
    setDuplicateShow(false);
    setTargetDate("");
  };

  
   return (
      <>
       <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>View Attendance Per Date</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <ViewAttendanceSessionsModal
          show={viewModal}
          onHide={() => setShowViewModal(false)}
        />
        <EditAttendanceSessionModal
          show={showModal}
          onHide={() => setShowModal(false)}
          mode={mode}
        />
        {/* optional place for Add button or filters if needed */}
        <ActionsDataTable
          columns={columns}
          filterColumns={filterColumns}
          data={rowData}
          pagination
          highlightOnHover
          striped
          responsive
          persistTableHead
          selectableRows
          selectableRowsHighlight
          selectableRowsVisibleOnly
          paginationServer={false}
          onSort={onSort}
          gridState={gridState}
          paginationTotalRows={rowData?.length}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onChangePage={onChangePage}
          paginationDefaultPage={defaultPage}
          paginationResetDefaultPage
          setGridState={setGridState}
          setShowModal={setShowModal}
          setMode={setMode}
          allowToolbar={true}
          allowFilters={false}
          extraToolbarActions={
            <div className="d-flex align-items-center gap-2">
              <select
                className="form-select form-select-sm"
                style={{ width: "135px", border: "1px solid #ced4da", borderRadius: 8, fontSize: 13, height: 38 }}
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
              >
                <option value="all">All Dates</option>
                <option value="daily">Today (Daily)</option>
                <option value="weekly">Last 7 Days</option>
                <option value="monthly">Last 30 Days</option>
              </select>
            </div>
          }
        />
      </Modal.Body>
    </Modal>

    {/* Duplicate Date Selector Modal */}
    <Modal show={duplicateShow} onHide={() => setDuplicateShow(false)} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Duplicate Attendance</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row justify-content-center align-items-center py-3">
          <div className="col-12 col-md-8 col-lg-6">
            <div className="card border-0 bg-light p-4 rounded-3">
              <div className="mb-3 text-center">
                <i className="bi bi-files text-primary" style={{ fontSize: "2.5rem" }} />
                <h5 className="mt-2 mb-1 fw-bold">Clone Daily Schedule</h5>
                <p className="text-muted small">
                  Copy all recorded sessions from <strong>{selectedRow?.date ? new Date(selectedRow.date).toLocaleDateString() : ""}</strong>
                </p>
              </div>
              
              <div className="mb-3">
                <label className="form-label fw-bold text-secondary" style={{ fontSize: 13 }}>
                  Select Target Date
                </label>
                <input
                  type="date"
                  max="9999-12-31"
                  className="form-control form-control-lg"
                  style={{ borderRadius: 10, fontSize: 15 }}
                  value={targetDate}
                  onChange={(e) => setTargetDate(e.target.value)}
                  required
                />
              </div>

              <div className="alert alert-info py-2 px-3 mb-0 d-flex align-items-start gap-2" style={{ borderRadius: 8 }}>
                <i className="bi bi-info-circle-fill text-info mt-1" style={{ fontSize: 14 }} />
                <div style={{ fontSize: 11, lineHeight: 1.4 }}>
                  If the target date already has attendance logs, they will be replaced with this duplicated clone.
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end footer-modal mt-0">
        <Button variant="outline-secondary" className="btn-footer" onClick={() => setDuplicateShow(false)}>
          Cancel
        </Button>
        <Button variant="success" className="btn-footer" onClick={handleDuplicateSubmit} disabled={!targetDate}>
          Duplicate
        </Button>
      </Modal.Footer>
    </Modal>
      
      </>
    );
}
